export const getEstimateTemplates = (state) => state.estimateTemplates
